import React, { useEffect } from "react";
import Navbar from "../components/Navbar";
import PaintVis from "../components/PaintVis";
import Herovis from "../components/Herovis";
import FAQvis from "../components/FAQvis";
import Footer from "../components/Footer";
import ScrollToTopButton from "../components/ScrollToTopButton";
export default function Paint() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Navbar />
      <Herovis />
      <PaintVis />
      <FAQvis />
      <Footer />
      <ScrollToTopButton />
    </>
  );
}
